import React from "react";
import { AiOutlineFilePdf } from "react-icons/ai";
import { FaFileAlt } from "react-icons/fa";

const FileGrid = ({ files, selectedFile, onFileSelect, newlyAddedItem,collapsed }) => {
  const getFileIcon = (file) => {
    if (file.fileType?.startsWith("image/")) {
      return (
        <img
          src={file.signedThumbUrl || file.signedUrl}
          alt={file.fileName}
          className="w-full h-full object-cover rounded"
          onError={(e) => {
            e.target.src = "/fallback-image.png"; // Optional fallback
          }}
        />
      );
    }
    if (file.fileType === "application/pdf") {
      return <AiOutlineFilePdf className="text-5xl text-gray-500" />;
    }
    return <FaFileAlt className="text-5xl text-gray-500" />;
  };

  const getBaseFileName = (name) => name.split(".")[0];


  return (
    <div className={`flex-1 grid  md:gap-4 gap-3 mt-5 ${collapsed ? 'xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 grid-cols-2' : 'xl:grid-cols-4 md:grid-cols-3 grid-cols-2'} `}>
      {files.map((file) => (
        <div
          key={file.mediaId || file.localId}
          className={`rounded-lg   cursor-pointer transition duration-150 `}
          onClick={() => onFileSelect(file)}
        >
          <div className={`w-full h-40 rounded bg-white p-1 flex items-center justify-center overflow-hidden
            ${selectedFile?.mediaId === file.mediaId
              ? "border-2 border-blue-500 shadow-md"
              : " "
            }
            `}>
            {getFileIcon(file)}
          </div>
          <div className=" p-2">
            <p className="text-sm font-medium truncate">{getBaseFileName(file.fileName)}</p>
            <p className="text-xs text-gray-500">
              {new Date(file.createdOn).toLocaleDateString()}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FileGrid;